import { inject } from '@angular/core';
import { CanMatchFn } from '@angular/router';
import { map } from 'rxjs/operators';

import { LeaguePublicResolverService } from '../shared/league-public-resolver.service';

/**
 * `CanMatch` for the `/:leagueCode` route: matches the league-v3 (glassmorphism)
 * route tree for every resolvable league EXCEPT those that explicitly opted out
 * with `publicViewStyle === 'classic'`. league-v3 is the default public view as
 * of 1.32.8.26. An explicit `classic`, or an unresolvable code, falls through to
 * the league-v2 tree, which renders its own not-found state.
 */
export const publicViewV3Guard: CanMatchFn = (_route, segments) => {
    const code = segments[0]?.path;
    if (!code) return false;

    return inject(LeaguePublicResolverService)
        .resolveByCode(code)
        .pipe(map(league => league != null && (league.publicViewStyle ?? 'glass') !== 'classic'));
};
